import AbstractController from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController';
import Controller from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller';
import AccessoryImageSlider from '../Elements/AccessoryImageSlider';
import ScrollTable from '../Elements/ScrollTable';
import ProductFinder from '../ProductFinder/ProductFinder';
import { $body } from '../../../../../../ig_template/Resources/Public/Src/Js/Constants';

/**
 * Product Controller
 *
 * @class
 */
class ProductController extends AbstractController {
	/**
	 * @constructor
	 */
	constructor() {
		super();
		Controller.registerController(this);
		this._registerElements(...ScrollTable);

		$body.find('[data-fancybox="accessories"]').fancybox({
			afterShow: (e) => {
				const $content = $(e.current.src);
				let slider = new AccessoryImageSlider($content.find('.accessory-image-slider'));
				slider.onReady();
			}
		});

		if ($('table.model-variants').length) {
			this._selectedVariant();
		}

		new ProductFinder($('#productFinder'));

		// Country flag
		this._countryFlag();
	}

	/**
	 * Get country flag
	 *
	 * @private
	 */
	_countryFlag()
	{
		var countryFlag = $body.find('#countryFlag');
		$.ajax({
			type: 'GET',
			url: '/index.php?type=3730',
			success: function(response){
				countryFlag.replaceWith(response);
			}
		});
	}

	/**
	 * Select variant chosen in product finder
	 * Replace shortcut nav with name of selected variant
	 *
	 * @private
	 */
	_selectedVariant()
	{
		let queryString = window.location.search;
		if (queryString) {
			// Get first part of query string
			queryString = queryString.slice(1).split('&')[0];
			// Should be something like "v=42", split it by "="
			let variant = queryString.split('=');
			// Check if it is really the v-parameter
			if (variant[0] === 'v') {
				// Get value of v-parameter which is the chosen variant in product finder
				let variantId = variant[1];
				// Get variant within model html
				let $variantTh = $('#v' + variantId);
				// Mark as "selected"
				$variantTh.addClass('selectedVariant');
				// Get variant name from html
				let variantName = $variantTh.html();
				// Get prefix "your selected variant" from data attribute of model variant table
				let prefix = $('table.model-variants').data('selectedvariant');
				// Replace shortcut nav with selected variant
				$('.shortcuts-bar nav.shortcuts-bar-links').html(prefix + ' <strong>' + variantName + '</strong>');
			}
		}
	}
}

export default (new ProductController);
